import React, { useEffect } from 'react';
import { BackHandler, View } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Colors, TouchableRipple } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons';

import WorkerProfile from './ProfileWorkerStackNavigator';
import WorkerLevel from './WorkerPNFAMStackNavigator';
import { WorkerBenefits, WorkerChallenges } from '../screens/worker';
import { pixelDimensions } from '../config/utils';
import { CenterFab } from '../components/common';
import { appColors } from '../assets/styles/global';
import { PlansPersonal } from '../screens/trainer';

const Profile = createBottomTabNavigator();

function ProfileWorker({ navigation }) {
  useEffect(() => {
    BackHandler.addEventListener('hardwareBackPress', () => true);
    return () => BackHandler.removeEventListener('hardwareBackPress', () => true);
  }, []);
  return (
    <View style={{ backgroundColor: Colors.grey300, flex: 1 }}>
      <Profile.Navigator
        tabBarOptions={{
          showLabel: false,
          style: {
            backgroundColor: appColors.primary,
            height: pixelDimensions(13),
          },
        }}
        screenOptions={({ route }) => ({
          tabBarButton: (props) => {
            const { children } = props;
            return <TouchableRipple rippleColor={Colors.white} {...props}>{children}</TouchableRipple>;
          },
          tabBarIcon: ({ focused }) => {
            let icon;
            const color = focused ? Colors.white : Colors.indigo100;
            // eslint-disable-next-line default-case
            switch (route.name) {
              case 'Profile': icon = 'person-circle-outline'; break;
              case 'Benefits': icon = 'cash-outline'; break;
              // case 'Worker Level':  icon = 'fitness-outline';          break;
              case 'Hire Trainer': icon = 'barbell-outline'; break;
              case 'Challenges': icon = 'trophy-outline'; break;
            }
            return <Icon name={icon} style={{ fontSize: pixelDimensions(9), color }} />;
          },
        })}
      >
        <Profile.Screen name="Profile" component={WorkerProfile} />
        <Profile.Screen name="Benefits" component={WorkerBenefits} />
        <Profile.Screen name="Worker Level" component={WorkerLevel} />
        <Profile.Screen
          name="Hire Trainer"
          component={PlansPersonal}
        />
        <Profile.Screen name="Challenges" component={WorkerChallenges} />
      </Profile.Navigator>
      <CenterFab icon="fitness-outline" onPress={() => navigation.navigate('Worker Level')} />
    </View>
  );
}

export default ProfileWorker;
